export enum FollowUp {
  FIRST = 'FIRST',
  LONG = 'LONG',
  USUAL = 'USUAL',
}
